// Helper API — semua panggilan ke backend lewat sini
const API = process.env.REACT_APP_BACKEND_URL;

async function req(path, { method = "GET", body, token } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const r = await fetch(`${API}/api${path}`, {
    method, headers, body: body ? JSON.stringify(body) : undefined
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const e = new Error(typeof j.detail === "string" ? j.detail : Array.isArray(j.detail) ? j.detail.map(d => d.msg || JSON.stringify(d)).join(" ") : `Error ${r.status}`);
    e.status = r.status;
    throw e;
  }
  return j;
}

export const api = {
  health: () => req("/health"),
  adminLogin: (email, password) => req("/admin/login", { method: "POST", body: { email, password } }),
  mayorLogin: (username, password) => req("/walikota/login", { method: "POST", body: { username, password } }),
  mayorMe: (t) => req("/walikota/me", { token: t }),
  mayorGetState: (t) => req("/walikota/state", { token: t }),
  mayorSaveState: (t, state) => req("/walikota/state", { method: "PUT", body: state, token: t }),
  listMayors: (t) => req("/admin/mayors", { token: t }),
  createMayor: (t, data) => req("/admin/mayors", { method: "POST", body: data, token: t }),
  patchMayor: (t, username, data) => req(`/admin/mayors/${username}`, { method: "PATCH", body: data, token: t }),
  deleteMayor: (t, username) => req(`/admin/mayors/${username}`, { method: "DELETE", token: t }),
  seedMayors: (t) => req("/admin/mayors/seed", { method: "POST", token: t }),
  catalog: () => req("/catalog"),
  createBuilding: (t, data) => req("/admin/catalog", { method: "POST", body: data, token: t }),
  patchBuilding: (t, bid, data) => req(`/admin/catalog/${bid}`, { method: "PATCH", body: data, token: t }),
  deleteBuilding: (t, bid) => req(`/admin/catalog/${bid}`, { method: "DELETE", token: t }),
  seedCatalog: (t) => req("/admin/catalog/seed", { method: "POST", token: t }),
  generatePaint: (t, bid, prompt, mode) => req("/admin/paint/generate", { method: "POST", body: { bid, prompt, mode: mode || "full" }, token: t }),
  paintStatus: (t, bid) => req(`/admin/paint/status/${bid}`, { token: t }),
  getDraft: (t, bid) => req(`/admin/catalog/${bid}/draft`, { token: t }),
  applyDraft: (t, bid) => req(`/admin/catalog/${bid}/draft/apply`, { method: "POST", token: t }),
  draftToVariant: (t, bid, name) => req(`/admin/catalog/${bid}/draft/variant`, { method: "POST", body: { name }, token: t }),
  discardDraft: (t, bid) => req(`/admin/catalog/${bid}/draft/discard`, { method: "POST", token: t }),
  saveVariant: (t, bid, name) => req(`/admin/catalog/${bid}/variants`, { method: "POST", body: { name }, token: t }),
  activateVariant: (t, bid, vid) => req(`/admin/catalog/${bid}/variants/${vid}/activate`, { method: "POST", token: t }),
  deleteVariant: (t, bid, vid) => req(`/admin/catalog/${bid}/variants/${vid}`, { method: "DELETE", token: t }),
  adminCities: (t) => req("/admin/cities", { token: t }),
  adminNamaKota: (t) => req("/admin/kota/nama", { token: t }),
  adminSetNamaKota: (t, id, nama) => req(`/admin/kota/${id}/nama`, { method: "PUT", body: { nama }, token: t }),
  adminOverview: (t) => req("/admin/overview", { token: t }),
  adminGetCityState: (t, id) => req(`/admin/city/${id}/state`, { token: t }),
  adminSaveCityState: (t, id, state) => req(`/admin/city/${id}/state`, { method: "PUT", body: state, token: t }),
  publicCities: () => req("/public/cities"),
  publicPenerbangan: () => req("/public/penerbangan"),
  publicPenerjun: username => req(`/public/penerjun/${encodeURIComponent(username)}`),
  adminBandara: (t) => req("/admin/bandara", { token: t }),
  adminPendatangTambah: (t, data) => req("/admin/pendatang", { method: "POST", body: data, token: t }),
  adminPendatangHapus: (t, username) => req(`/admin/pendatang/${encodeURIComponent(username)}`, { method: "DELETE", token: t }),
  adminKataPemicu: (t, kata) => req("/admin/pendatang/kata_pemicu", { method: "POST", body: { kata }, token: t }),
  adminSimulasiKomentar: (t, jumlah) => req("/admin/pendatang/simulasi_komentar", { method: "POST", body: { jumlah }, token: t }),
  adminAntreanUlang: (t, id) => req(`/admin/antrean_kirim/${id}/ulang`, { method: "POST", token: t }),
  publicCity: (id) => req(`/public/city/${id}`),
  likeCity: (id, visitor) => req(`/public/city/${id}/like?visitor_id=${visitor}`, { method: "POST" }),
  getComments: (id) => req(`/public/city/${id}/comments`),
  addComment: (id, name, text) => req(`/public/city/${id}/comments`, { method: "POST", body: { name, text } }),

  // ----- Konten: Radio, Koran, Info, Pesan Warga -----
  adminRadio: (t) => req("/admin/radio", { token: t }),
  publicRadio: () => req("/radio"),
  addTrack: (t, data) => req("/admin/radio/tracks", { method: "POST", body: data, token: t }),
  patchTrack: (t, id, data) => req(`/admin/radio/tracks/${id}`, { method: "PATCH", body: data, token: t }),
  deleteTrack: (t, id) => req(`/admin/radio/tracks/${id}`, { method: "DELETE", token: t }),
  reorderTracks: (t, ids) => req("/admin/radio/tracks/reorder", { method: "POST", body: { ids }, token: t }),
  addAnnounce: (t, data) => req("/admin/radio/announcements", { method: "POST", body: data, token: t }),
  patchAnnounce: (t, id, data) => req(`/admin/radio/announcements/${id}`, { method: "PATCH", body: data, token: t }),
  deleteAnnounce: (t, id) => req(`/admin/radio/announcements/${id}`, { method: "DELETE", token: t }),
  buatAudioAnnounce: (t, id) => req(`/admin/radio/announcements/${id}/audio`, { method: "POST", token: t }),
  getNarator: (t) => req("/admin/radio/narator", { token: t }),
  patchNarator: (t, data) => req("/admin/radio/narator", { method: "PATCH", body: data, token: t }),
  ujiNarator: (t, data) => req("/admin/radio/narator/uji", { method: "POST", body: data, token: t }),
  voicesElevenLabs: (t, api_key) => req("/admin/radio/narator/voices", { method: "POST", body: { api_key }, token: t }),
  adminKoran: (t) => req("/admin/koran", { token: t }),
  createKoran: (t, data) => req("/admin/koran", { method: "POST", body: data, token: t }),
  patchKoran: (t, id, data) => req(`/admin/koran/${id}`, { method: "PATCH", body: data, token: t }),
  deleteKoran: (t, id) => req(`/admin/koran/${id}`, { method: "DELETE", token: t }),
  publicKoran: (cityId) => req(`/koran${cityId ? `?city_id=${cityId}` : ""}`),
  adminInfo: (t) => req("/admin/info", { token: t }),
  createInfo: (t, data) => req("/admin/info", { method: "POST", body: data, token: t }),
  patchInfo: (t, id, data) => req(`/admin/info/${id}`, { method: "PATCH", body: data, token: t }),
  reorderInfo: (t, ids) => req("/admin/info/reorder", { method: "POST", body: { ids }, token: t }),
  deleteInfo: (t, id) => req(`/admin/info/${id}`, { method: "DELETE", token: t }),
  publicInfo: () => req("/info"),
  publicArticle: (id) => req(`/koran/${id}`),
  publicPesan: () => req("/pesan"),
  wargaAsliKota: (city_id) => req(`/public/city/${city_id}/warga-asli`),
  wargaVerifikasi: (ig_username, kode, city_id) => req("/warga/verifikasi", { method: "POST", body: { ig_username, kode, city_id: city_id || null } }),
  permohonanAjukan: (ig_username, city_id) => req("/warga/permohonan", { method: "POST", body: { ig_username, city_id } }),
  permohonanPantau: (id) => req(`/warga/permohonan/${id}`),
  wargaPin: (t, pin, pin_lama) => req("/warga/pin", { method: "POST", body: { pin, pin_lama: pin_lama || null }, token: t }),
  wargaMasuk: (ig_username, pin) => req("/warga/masuk", { method: "POST", body: { ig_username, pin } }),
  lupaPin: (ig_username) => req("/warga/lupa-pin", { method: "POST", body: { ig_username } }),
  // Rumah Warga
  rumahKatalog: () => req("/rumah/katalog"),
  rumahCari: (q, kota) => req(`/rumah/cari?q=${encodeURIComponent(q || "")}${kota ? `&kota=${encodeURIComponent(kota)}` : ""}`),
  rumahSaya: (t) => req("/rumah/saya", { token: t }),
  rumahLihat: (ig, t) => req(`/rumah/${encodeURIComponent(ig)}`, { token: t }),
  rumahKunjungan: (ig, vid, t) => req(`/rumah/${encodeURIComponent(ig)}/kunjungan`, { method: "POST", body: { vid }, token: t }),
  rumahSuka: (ig, t) => req(`/rumah/${encodeURIComponent(ig)}/suka`, { method: "POST", token: t }),
  rumahBukuTamu: (ig, pesan, t) => req(`/rumah/${encodeURIComponent(ig)}/buku-tamu`, { method: "POST", body: { pesan }, token: t }),
  rumahHapusBukuTamu: (t, bid) => req(`/rumah/saya/buku-tamu/${bid}`, { method: "DELETE", token: t }),
  rumahHias: (t, data) => req("/rumah/saya/hias", { method: "PUT", body: data, token: t }),
  rumahHalaman: (t, items) => req("/rumah/saya/halaman", { method: "PUT", body: { items }, token: t }),
  rumahParkir: (t, parkir) => req("/rumah/saya/parkir", { method: "PUT", body: parkir, token: t }),
  rumahCatKendaraan: (t, key, warna) => req("/rumah/saya/kendaraan-warna", { method: "PUT", body: { key, warna }, token: t }),
  rumahTanam: (t, slot, bibit) => req(`/rumah/saya/kebun/${slot}/tanam`, { method: "POST", body: { bibit }, token: t }),
  rumahPanen: (t, slot) => req(`/rumah/saya/kebun/${slot}/panen`, { method: "POST", token: t }),
  rumahPanenSemua: (t) => req("/rumah/saya/kebun/panen-semua", { method: "POST", token: t }),
  rumahInterior: (t, body) => req("/rumah/saya/interior", { method: "PUT", body, token: t }),
  rumahBukaSlot: (t) => req("/rumah/saya/kebun/buka", { method: "POST", token: t }),
  rumahIstirahat: (t) => req("/rumah/saya/istirahat", { method: "POST", token: t }),
  wargaAktif: (t, halaman) => req("/warga/aktif", { method: "POST", body: { halaman }, token: t }),
  kunjungan: (vid, city_id) => req("/kunjungan", { method: "POST", body: { vid, city_id } }),
  // Admin: statistik live + Panel Database Warga + moderasi Pesan Warga
  adminLive: (t) => req("/admin/live", { token: t }),
  adminPerkembangan: (t, hari = 14) => req(`/admin/perkembangan?hari=${hari}`, { token: t }),
  adminWargaDb: (t, params = {}) => req(`/admin/warga-db?${new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null)))}`, { token: t }),
  adminWargaDetail: (t, id) => req(`/admin/warga-db/${id}`, { token: t }),
  adminWargaKoin: (t, id, data) => req(`/admin/warga-db/${id}/koin`, { method: "POST", body: data, token: t }),
  adminWargaChat: (t, id, blokir) => req(`/admin/warga-db/${id}/chat`, { method: "POST", body: { blokir }, token: t }),
  adminPesanFilter: (t) => req("/admin/pesan-filter", { token: t }),
  adminSimpanPesanFilter: (t, data) => req("/admin/pesan-filter", { method: "PUT", body: data, token: t }),
  wargaMe: (t) => req("/warga/me", { token: t }),
  wargaPostPesan: (t, text) => req("/warga/pesan", { method: "POST", body: { text }, token: t }),
  adminPesan: (t) => req("/admin/pesan", { token: t }),
  adminPesanUnread: (t) => req("/admin/pesan?limit=1", { token: t }),
  // ----- Data & migrasi (cadangan, pulihkan, tarik dari server lain) -----
  adminDataRingkasan: (t) => req("/admin/data/ringkasan", { token: t }),
  adminDataEkspor: (t) => req("/admin/data/ekspor", { token: t }),
  adminDataImpor: (t, snap) => req("/admin/data/impor", { method: "POST", body: snap, token: t }),
  adminDataTarik: (t, body) => req("/admin/data/tarik", { method: "POST", body, token: t }),
  adminDataStatus: (t) => req("/admin/data/status", { token: t }),
  // ----- Ekonomi warga: dompet koin, profesi & shift kerja -----
  ekonomiProfesi: () => req("/ekonomi/profesi"),
  ekonomiMisi: () => req("/ekonomi/misi"),
  ekonomiMisiSaya: (t) => req("/ekonomi/misi/saya", { token: t }),
  misiIkut: (t, id) => req(`/ekonomi/misi/${id}/ikut`, { method: "POST", token: t }),
  misiKlaim: (t, id) => req(`/ekonomi/misi/${id}/klaim`, { method: "POST", token: t }),
  ekonomiProfil: (t) => req("/ekonomi/profil", { token: t }),
  peringkat: (mode, periode) => req(`/ekonomi/peringkat?mode=${mode}&periode=${periode}`),
  ekonomiDompet: (t) => req("/ekonomi/dompet", { token: t }),
  ekonomiPilihProfesi: (t, profesi) => req("/ekonomi/profesi", { method: "POST", body: { profesi }, token: t }),
  ekonomiPilihUtama: (t, profesi) => req("/ekonomi/profesi/utama", { method: "POST", body: { profesi }, token: t }),
  ekonomiMulai: (t) => req("/ekonomi/kerja/mulai", { method: "POST", token: t }),
  ekonomiSelesai: (t, shift_id, skor) => req("/ekonomi/kerja/selesai", { method: "POST", body: { shift_id, skor }, token: t }),
  // ----- Mall Jawsel (publik/warga) & Studio AI Mall (admin) -----
  mallKatalog: () => req("/mall/katalog"),
  mallKode: (ids) => req(`/mall/kode?ids=${encodeURIComponent(ids)}`),
  mallTas: (t) => req("/mall/tas", { token: t }),
  mallBeli: (t, id) => req(`/mall/beli/${id}`, { method: "POST", token: t }),
  mallSet: () => req("/mall/set"),
  mallBeliSet: (t, key) => req(`/mall/beli-set/${key}`, { method: "POST", token: t }),
  mallPakai: (t, id) => req(`/mall/pakai/${id}`, { method: "POST", token: t }),
  suratRingkas: (t) => req("/surat/ringkas", { token: t }),
  suratPercakapan: (t) => req("/surat/percakapan", { token: t }),
  suratDengan: (t, ig) => req(`/surat/dengan/${encodeURIComponent(ig)}`, { token: t }),
  suratKirim: (t, ke, teks) => req("/surat/kirim", { method: "POST", body: { ke, teks }, token: t }),
  suratTeman: (t) => req("/surat/teman", { token: t }),
  suratTambahTeman: (t, ig) => req(`/surat/teman/${encodeURIComponent(ig)}`, { method: "POST", token: t }),
  suratHapusTeman: (t, ig) => req(`/surat/teman/${encodeURIComponent(ig)}`, { method: "DELETE", token: t }),
  suratCari: (t, q) => req(`/surat/cari?q=${encodeURIComponent(q)}`, { token: t }),
  kabar: (t) => req("/kabar", { token: t }),
  kabarRingkas: (t) => req("/kabar/ringkas", { token: t }),
  kabarLihat: (t) => req("/kabar/lihat", { method: "POST", token: t }),
  toaSekarang: () => req("/toa/sekarang"),
  toaKirim: (t, teks) => req("/toa", { method: "POST", body: { teks }, token: t }),
  toaPesananSaya: (t) => req("/toa/pesanan/saya", { token: t }),
  toaPesanan: (t, id) => req(`/toa/pesanan/${id}`, { token: t }),
  adminToaPengaturan: (t) => req("/toa/admin/pengaturan", { token: t }),
  adminToaSimpan: (t, body) => req("/toa/admin/pengaturan", { method: "PUT", body, token: t }),
  misiHarian: (t) => req("/misi/harian", { token: t }),
  misiRingkas: (t) => req("/misi/ringkas", { token: t }),
  misiAksi: (t, key) => req(`/misi/aksi/${key}`, { method: "POST", token: t }),
  misiKlasemen: (t) => req("/misi/klasemen", { token: t }),
  adminMallItems: (t) => req("/admin/mall/items", { token: t }),
  adminToko: (t) => req("/admin/mall/toko", { token: t }),
  adminSponsorGambar: (t, data_url) => req("/admin/sponsor/gambar", { method: "POST", body: { data_url }, token: t }),
  adminTokoPromo: (t, body) => req("/admin/mall/toko/promo", { method: "PUT", body, token: t }),
  adminTokoHargaMassal: (t, body) => req("/admin/mall/toko/harga-massal", { method: "POST", body, token: t }),
  adminTokoSetSimpan: (t, body) => req("/admin/mall/toko/set", { method: "POST", body, token: t }),
  adminTokoSetHapus: (t, key) => req(`/admin/mall/toko/set/${key}`, { method: "DELETE", token: t }),
  adminMallBuat: (t, data) => req("/admin/mall/items", { method: "POST", body: data, token: t }),
  adminMallUbah: (t, id, data) => req(`/admin/mall/items/${id}`, { method: "PUT", body: data, token: t }),
  adminMallHapus: (t, id) => req(`/admin/mall/items/${id}`, { method: "DELETE", token: t }),
  adminMallTerbitkan: (t, id) => req(`/admin/mall/items/${id}/terbitkan`, { method: "POST", token: t }),
  adminMallTarik: (t, id) => req(`/admin/mall/items/${id}/tarik`, { method: "POST", token: t }),
  adminMallGenerate: (t, id, prompt, mode) => req(`/admin/mall/items/${id}/generate`, { method: "POST", body: { prompt: prompt || "", mode: mode || "full" }, token: t }),
  adminMallStatus: (t, id) => req(`/admin/mall/items/${id}/status`, { token: t }),
  adminMallPakaiDraf: (t, id) => req(`/admin/mall/items/${id}/draf/pakai`, { method: "POST", token: t }),
  adminMallBuangDraf: (t, id) => req(`/admin/mall/items/${id}/draf/buang`, { method: "POST", token: t }),
  // ----- Alun-alun: karakter, toko aksesori, info ruangan -----
  alunOpsi: () => req("/alun/opsi"),
  alunAvatar: (t) => req("/alun/avatar", { token: t }),
  alunSimpanAvatar: (t, data) => req("/alun/avatar", { method: "PUT", body: data, token: t }),
  alunBeli: (t, item) => req("/alun/toko/beli", { method: "POST", body: { item }, token: t }),
  alunInfo: (cityId) => req(`/alun/${cityId}/info`),
  adminPostPesan: (t, text) => req("/admin/pesan", { method: "POST", body: { text }, token: t }),
  patchPesan: (t, id, data) => req(`/admin/pesan/${id}`, { method: "PATCH", body: data, token: t }),
  readAllPesan: (t) => req("/admin/pesan/read-all", { method: "POST", token: t }),
  deletePesan: (t, id) => req(`/admin/pesan/${id}`, { method: "DELETE", token: t }),
  adminWarga: (t) => req("/admin/warga", { token: t }),
  addWarga: (t, data) => req("/admin/warga", { method: "POST", body: data, token: t }),
  patchWarga: (t, id, data) => req(`/admin/warga/${id}`, { method: "PATCH", body: data, token: t }),
  regenKodeWarga: (t, id) => req(`/admin/warga/${id}/kode`, { method: "POST", token: t }),
  igStatus: (t) => req("/admin/instagram/status", { token: t }),
  igSimulasi: (t, data) => req("/admin/instagram/simulasi", { method: "POST", body: data, token: t }),
  igCek: (t) => req("/admin/instagram/cek", { token: t }),
  igDaftarWebhook: (t) => req("/admin/instagram/daftar_webhook", { method: "POST", token: t }),
  deleteWarga: (t, id) => req(`/admin/warga/${id}`, { method: "DELETE", token: t }),

  // Unggah berpotongan (512 KB) → object storage; onProgress(0..1). Mengembalikan dokumen media {id, url, ...}
  async uploadMedia(token, file, kind, onProgress) {
    const init = await req("/upload/init", { method: "POST", token, body: { filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, kind } });
    const { upload_id, chunk_size } = init;
    const total = Math.ceil(file.size / chunk_size);
    for (let i = 0; i < total; i++) {
      const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
      const r = await fetch(`${API}/api/upload/${upload_id}/chunk/${i}`, { method: "PUT", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/octet-stream" }, body: blob });
      if (!r.ok) throw new Error(`Potongan ${i + 1}/${total} gagal (${r.status})`);
      onProgress?.((i + 1) / total);
    }
    return req(`/upload/${upload_id}/finish`, { method: "POST", token });
  },
  mediaUrl: (idOrPath) => (idOrPath ? (idOrPath.startsWith("http") ? idOrPath : `${API}${idOrPath.startsWith("/api") ? idOrPath : `/api/media/${idOrPath}`}`) : null),
};
